import { Component, OnDestroy, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BcStateListContext } from '@bayclubs/state';

import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ValidationService as CoreValidationService } from '@bayclubs/ui-core';

import { ValidationService } from '@shared/shared.module';

import { PersonModel } from '@bayclubs/court-booking-employee-api';
import { PlayersFacade } from '../../+store/players.facade';

@Component({
    selector: 'app-player-add',
    templateUrl: './player-add.component.html',
    styleUrls: ['./player-add.component.scss'],
    standalone: false
})
export class PlayerAddComponent implements OnInit, OnDestroy {
    player$ = this.playerFacade.player$;
    players$ = this.playerFacade.players$;

    form: UntypedFormGroup;

    subscription: Subscription = new Subscription();
    constructor(
        private playerFacade: PlayersFacade,
        private formBuilder: UntypedFormBuilder,
        private coreValidation: CoreValidationService
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            email: [null, [
                Validators.required,
                ValidationService.oneOfValidator(
                    [this.coreValidation.emailValidator(), this.coreValidation.phoneNumberValidator],
                    { invalidEmailOrPhone: true }
                )
            ]]
        });
        this.initFormSubscription();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    initFormSubscription() {
        this.subscription.add(
            this.form.controls.email.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
                if (this.form.valid) {
                    this.playerFacade.searchPlayers(value);
                } else {
                    this.playerFacade.clearPlayers();
                }
            })
        );
    }

    addPlayer() {
        let email = null;
        let phone = null;
        if (this.coreValidation.phoneNumberValidator(this.form.controls.email as UntypedFormControl) === null) {
            phone = this.form.controls.email.value;
        } else {
            email = this.form.controls.email.value;
        }
        this.playerFacade.addPlayer(email, phone);
    }

    public canAddPlayer(players: BcStateListContext<PersonModel>): boolean {
        return this.form.valid && !players.hasItems;
    }
}
